import HttpService from '@src/utility/httpService';
import { checkIsInternal } from '@src/utility/createStorage';
import { config } from '@uhg-abyss/web/tools/config';
const _httpService = new HttpService();

if (checkIsInternal()) {
  _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
} else {
  _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
}

export const getPSMSDigitalSolutionSummary = (payload: any) => {
  const fetchData = async () => {
    try {
      const response: any = await _httpService.push('/edi-adoption-rate', payload);
      return response;
    } catch {
      return null;
    }
  };
  return fetchData();
};

export const getPSMSDigitalSolutionAdoptionRate = (payload: any) => {
  const fetchData = async () => {
    try {
      const response: any = await _httpService.push('/providersystems', payload);
      return response;
    } catch {
      return null;
    }
  };
  return fetchData();
};
